import React from 'react';
import '../static/Footer.css'

const Footer = () => {
  return (
    <div id="Footer">
        <div className="wrapper">
            <p>&copy; SSS North Fairview Homes, Inc 2020.</p>
            <p>Powered by JJ Solution Dev Experts</p>
        </div>
    </div>
  );
}

export default Footer;
